import { getFloors, getBuildings } from '@/controllers/BaseController'
import { getHardwareByType } from '@/controllers/BackboneAPI'
import lodash from 'lodash'
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

// Toast utility with gradient colors
export const showToast = (message, type = 'default') => {
  const background =
    {
      success: 'linear-gradient(to right, #4caf50, #2e7d32)',
      error: 'linear-gradient(to right, #f44336, #b71c1c)',
      info: 'linear-gradient(to right, #2196f3, #0d47a1)',
      warning: 'linear-gradient(to right, #ff9800, #e65100)',
      default: 'linear-gradient(to right, #9e9e9e, #616161)',
    }[type] || 'linear-gradient(to right, #9e9e9e, #616161)'

  Toastify({
    text: message,
    duration: 3000,
    gravity: 'bottom',
    position: 'center',
    style: {
      background,
      borderRadius: '10px',
      padding: '12px 24px',
      color: '#fff',
      fontWeight: 'bold',
    },
    offset: {
      y: 50, // lifted from bottom
    },
  }).showToast()
}

export const loadLocksHelper = async () => {
  try {
    // showToast('🔄 Loading locks...', 'info')

    const building = (await getBuildings())[0]
    if (!building) {
      //showToast('❌ No building found', 'error')
      return []
    }

    const [locksData, floors] = await Promise.all([getHardwareByType(building.id, 'lock'), getFloors()])

    const floorMap = Object.fromEntries(floors.map(f => [f.id, f]))

    const result = lodash.orderBy(
      locksData.map(l => ({
        ...l,
        floor: floorMap[l?.location?.floorId],
        blueIdObjectId: l?.configs?.['blue-id-object-id'],
      })),
      [l => (/^\d/.test(l?.configs?.name || '') ? '1' : '2') + (l?.configs?.name || '')],
      ['asc']
    )

    //  showToast(`✅ Loaded ${result.length} locks`, 'success')
    return result
  } catch (e) {
    console.error('🔴 loadLocksHelper failed:', e)
    // showToast('❌ Failed to load locks', 'error')
    return []
  }
}
